import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleCliente } from "../hooks/roles/ProtectedRoleCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleAprobar = React.lazy(
  () => import("../components/task/tareaDetalleAprobar/tarea-detalle-aprobar")
);
export function tareaDetalleAprobar() {
  return (
    <Route
      path="/tarea-detalle-aprobar"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleCliente>
              <LazySuspense>
                <TareaDetalleAprobar />
              </LazySuspense>
            </ProtectedRoleCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
